import React from "react";

const colStyles = {
  paddingLeft: "0",
  paddingRight: "0",
};

const rowStyles = {
  marginLeft: "0",
  marginRight: "0",
};

/**
 * Display bonus entry status
 * @param {Object} props - Component props
 * @param {boolean} props.isButton - Whether the status is displayed as a button
 * @returns {import("react").ReactElement} React component
 */
export default function BonusEntryStatus(props) {
  const { isButton } = props;

  return (
    <div className="earn-more">
      <div
        style={{
          background:
            "linear-gradient(135deg, rgba(76, 175, 80, 0.08) 0%, rgba(33, 150, 243, 0.08) 100%)",
          marginLeft: "-15px",
          marginRight: "-15px",
          marginTop: "0px",
          paddingTop: "15px",
          borderBottomWidth: "2px",
          borderBottomStyle: "solid",
          borderBottomColor: "#4CAF50",
          borderTopWidth: isButton ? "2px" : null,
          borderTopStyle: isButton ? "solid" : null,
          borderTopColor: isButton ? "#4CAF50" : null,
        }}
      >
        <div className="row" style={rowStyles}>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" style={colStyles}>
            <p
              style={{
                margin: "0",
                fontSize: "24px",
                fontFamily: "sans-serif",
                fontWeight: "bold",
                color: "#2d6e4e",
              }}
            >
              <span className="bonus-scored" style={{ color: "#4CAF50" }}>
                4
              </span>
              <span style={{ color: "#666", margin: "0 3px" }}>/</span>
              <span className="bonus-total" style={{ color: "#2196F3" }}>
                35
              </span>
            </p>
          </div>
        </div>
        <div className="row text-center" style={rowStyles}>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={colStyles}>
            <p
              style={{
                fontSize: "16px",
                fontFamily: "sans-serif",
                fontWeight: "bold",
                color: "#666",
                letterSpacing: "1px",
              }}
            >
              ENTRIES
            </p>
          </div>
        </div>
      </div>
      <div
        style={{
          marginLeft: "-15px",
          marginRight: "-15px",
          marginTop: "-15px",
          paddingTop: "15px",
        }}
      >
        <div className="row" style={rowStyles}>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" style={colStyles}>
            <div
              style={{
                marginLeft: "calc(50% - 150px)",
              }}
            >
              <div
                style={{
                  height: "90px",
                  display: "table-cell",
                  verticalAlign: "middle",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    fontFamily: "sans-serif",
                    color: "#384645",
                    fontWeight: "bold",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ color: "#FFD700", fontSize: "18px" }}>★</span>
                  Earn more entries by completing these actions
                  <span style={{ color: "#FFD700", fontSize: "18px" }}>★</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
